<template>
  <div>
    Form
  </div>
</template>

<script>

export default {
  data () {
    return {
      stupidVar: null
    }
  },
  components: {
  },
  mounted () {
    console.log(this.$route.query.component)
  }
}
</script>
